import environment from './generated/environment';
import logger from './logger';
// expose version info, so it can be checked using the browser console
if (typeof window !== 'undefined') {
    var win = window;
    if (!win.awsuiVersions) {
        win.awsuiVersions = {};
    }
    if (!win.awsuiVersions.components) {
        win.awsuiVersions.components = [];
    }
    win.awsuiVersions.components.push(environment.PACKAGE_VERSION);
}
var oneTimeMetrics = {};
var getMajorVersion = function (versionString) {
    var majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
    return majorVersionMatch ? majorVersionMatch[1] : '';
};
var buidlMetricDetail = function (_a) {
    var source = _a.source, action = _a.action, version = _a.version;
    var detailObject = {
        s: source,
        t: environment.UI_THEME,
        a: action,
        f: framework,
        v: version.replace(/\s/g, '')
    };
    return JSON.stringify(detailObject);
};
var buidlMetricHash = function (_a) {
    var source = _a.source, action = _a.action;
    return ["src" + source, "action" + action].join('_');
};
var buildMetricName = function (_a) {
    var source = _a.source, action = _a.action, version = _a.version;
    var majorVersion = getMajorVersion(version);
    return ['awsui', source, "" + environment.UI_THEME.charAt(0) + majorVersion.replace('.', '')].join('_');
};
var findAWSC = function (currentWindow) {
    var _a, _b;
    try {
        if (typeof ((_a = currentWindow) === null || _a === void 0 ? void 0 : _a.AWSC) === 'object') {
            return (_b = currentWindow) === null || _b === void 0 ? void 0 : _b.AWSC;
        }
        if (!currentWindow || currentWindow.parent === currentWindow) {
            // When the window has no more parents, it references itself
            return undefined;
        }
        return findAWSC(currentWindow.parent);
    }
    catch (ex) {
        // Most likely a cross-origin access error
        return undefined;
    }
};
var framework = '';
function setFramework(fwk) {
    framework = fwk;
}
export default {
    initMetrics: function (fwk) {
        setFramework(fwk);
        this.sendMetricObjectOnce({
            source: 'components',
            action: 'loaded',
            version: environment.PACKAGE_VERSION
        }, 1);
    },
    /**
     * Calls Console Platform's client logging JS API with provided metric name, value, and detail.
     * Does nothing if Console Platform client logging JS is not present in page.
     */
    sendMetric: function (metricName, value, detail) {
        if (!metricName || !/^[a-zA-Z0-9_-]{1,32}$/.test(metricName)) {
            logger.error("Invalid metric name: " + metricName);
            return;
        }
        if (detail && detail.length > 200) {
            logger.error("Detail for metric " + metricName + " is too long: " + detail);
            return;
        }
        if (typeof window !== 'undefined') {
            var AWSC = findAWSC(window);
            if (typeof AWSC === 'object' && typeof AWSC.Clog === 'object' && typeof AWSC.Clog.log === 'function') {
                AWSC.Clog.log(metricName, value, detail);
            }
        }
    },
    sendMetricObject: function (metric, value) {
        this.sendMetric(buildMetricName(metric), value, buidlMetricDetail(metric));
    },
    sendMetricObjectOnce: function (metric, value) {
        var metricHash = buidlMetricHash(metric);
        if (!oneTimeMetrics[metricHash]) {
            this.sendMetricObject(metric, value);
            oneTimeMetrics[metricHash] = true;
        }
    },
    /*
     * Calls Console Platform's client logging only the first time the provided metricName is used.
     * Subsequent calls with the same metricName are ignored.
     */
    sendMetricOnce: function (metricName, value, detail) {
        if (!oneTimeMetrics[metricName]) {
            this.sendMetric(metricName, value, detail);
            oneTimeMetrics[metricName] = true;
        }
    },
    /*
     * Reports a metric value 1 to Console Platform's client logging service to indicate that the
     * component was used in the page.  A component will only be reported as used to client logging
     * service once per page view.
     */
    logComponentUsed: function (component) {
        var source = component.__componentName.replace(/^awsui-/, '').replace(/-/g, '');
        this.sendMetricObjectOnce({
            source: source,
            action: 'used',
            version: component.__componentVersion
        }, 1);
    }
};
//# sourceMappingURL=metrics.js.map